import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const ProductFintech = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 40 40">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="#F5E4E7"/>
      <g clipPath="url(#clip0_16014_102224)">
      <path d="M20.0013 28.3334C24.6037 28.3334 28.3346 24.6024 28.3346 20C28.3346 15.3976 24.6037 11.6667 20.0013 11.6667C15.3989 11.6667 11.668 15.3976 11.668 20C11.668 24.6024 15.3989 28.3334 20.0013 28.3334Z" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11.668 20H28.3346" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M20.0013 11.6667C22.0857 13.9486 23.2703 16.91 23.3346 20C23.2703 23.09 22.0857 26.0514 20.0013 28.3334C17.9169 26.0514 16.7323 23.09 16.668 20C16.7323 16.91 17.9169 13.9486 20.0013 11.6667V11.6667Z" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
      <clipPath id="clip0_16014_102224">
      <rect width="20" height="20" fill="white" transform="translate(10 10)"/>
      </clipPath>
      </defs>
      </svg>
    </SvgIcon>
  );
}

export default ProductFintech;

